import {Component, Input, OnInit} from '@angular/core';
import {
  SetUpGridPlayersManagementComponent
} from '../set-up-grid-players-management/set-up-grid-players-management.component';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
@Component({
  selector: 'app-set-up-grid-players-managment-button',
  templateUrl: './set-up-grid-players-managment-button.component.html',
  styleUrls: ['./set-up-grid-players-managment-button.component.scss']
})
export class SetUpGridPlayersManagmentButtonComponent implements OnInit {

  @Input() enableGenerationSwitch: string;
  public buttonIsVisible: boolean = !!window['iAmStaff'];
  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
    this.buttonIsVisible &&= this.enableGenerationSwitch === 'True';
  }

  onClickHandler($event) {
    this.modalService.open(SetUpGridPlayersManagementComponent, {
      size: '50%',
      centered: true,
      windowClass: 'modalStyle',
    });
  }

}
